import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';

import {stringUtils} from 'front-onceforall-core';

import {useHistory, useLocation} from 'react-router-dom';
import {USER_REQUEST_TYPES} from '../../../../utils/constant';

import LinkButtonView from '../../../buttons/link';

function DetailsView(props) {
  const location = useLocation();
  const history = useHistory();

  function onClickHelp() {
    history.replace(`${location.pathname}?help=NB_CLIENTS`);
  }

  const displayRemainingUserAccounts = () => (
    <p className="mr-5">
      {stringUtils.getStrongs(I18n.t(
        'subscription.remainingUserAccounts',
        {count: props.subscription.remainingUserAccounts}
      ))}
    </p>
  );

  const displayNbClients = () => {
    const {nbClients} = props.subscription;
    if (!Number.isInteger(nbClients)) {
      return null;
    }
    return (
      <div
        data-id="subscription.nbClients"
        className="mx-5"
      >
        <p>
          {stringUtils.getStrongs(I18n.t(
            'subscription.nbClients',
            {count: nbClients}
          ))}
        </p>
        <p>
          {I18n.t('subscription.help.firstPart')}
          <a
            data-id="subscription.help"
            onClick={onClickHelp}
          >
            {I18n.t('subscription.help.link')}
          </a>
          {I18n.t('subscription.help.secondPart')}
        </p>
      </div>
    );
  };

  const displayValidUntil = () => {
    if (!props.subscription?.validUntil) { return null; }
    return (
      <p className="ml-5">
        {stringUtils.getStrongs(
          I18n.t(
            'subscription.validUntil',
            {date: I18n.l(props.subscription.validUntil, {dateFormat: 'datetime.shortDate'})}
          )
        )}
      </p>
    );
  };

  return (
    <>
      <h2>
        <Translate value="subscription.title"/>
      </h2>
      <div className="card">
        {props.loading && <div className="loading-overlay"/>}

        {!props.subscription &&
        <>
          <div className="table-without-result">
            <Translate value="subscription.noResult"/>
          </div>
        </>
        }

        {!props.loading && props.subscription &&
        <>
          <p>
            <strong className="information-primary uppercase font-size-xl">
              <Translate value={`subscriptions.plans.title.${props.subscription.planId}`}/>
            </strong>
          </p>
          <p className="">
            <strong>
              <Translate
                value={props.subscription.depositorServiceAuthorized ?
                  'subscription.collector_and_depositor' : 'subscription.collector'}
              />
            </strong>
          </p>
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-fill">
              {displayRemainingUserAccounts()}
              {displayNbClients()}
              {displayValidUntil()}
            </div>
            <div className="mr-5">
              {props.subscription.upgradable &&
                <LinkButtonView
                  link={'/register-organisation-plan'}
                  buttonLabel={<Translate value="plan.actions.upgrade"/>}
                />
              }
              {!props.subscription.upgradable &&
                <LinkButtonView
                  link={`${props.pathname}?contact=${USER_REQUEST_TYPES.MY_OFFER}`}
                  buttonLabel={<Translate value="plan.actions.contactUs"/>}
                />
              }
            </div>
          </div>
        </>
        }
      </div>
    </>
  );
}

DetailsView.propTypes = {
  pathname: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  subscription: PropTypes.shape({
    planId: PropTypes.string.isRequired,
    depositorServiceAuthorized: PropTypes.bool.isRequired,
    remainingUserAccounts: PropTypes.number.isRequired,
    upgradable: PropTypes.bool.isRequired,
    validUntil: PropTypes.string.isRequired,
    nbClients: PropTypes.number
  })
};

export default DetailsView;
